import { render, staticRenderFns } from "./PopupAddVenueAlias.vue?vue&type=template&id=b1ca24d6&scoped=true&"
import script from "./PopupAddVenueAlias.vue?vue&type=script&lang=js&"
export * from "./PopupAddVenueAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ca24d6",
  null
  
)

export default component.exports